import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "./api";
import { useAuth } from "../context/AuthContext";

const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();

export function useSedi() {
  const { user } = useAuth();
  const { data = [] } = useQuery({ queryKey: ["sedi-dep"], enabled: !!user, staleTime: 60000, queryFn: async () => (await api.get("/dependance/sedi")).data });
  return React.useMemo(() => {
    const byId = {}, byName = {};
    data.forEach((s) => { byId[s.ospite_id] = s; byName[norm(`${s.cognome} ${s.nome}`)] = s; byName[norm(`${s.nome} ${s.cognome}`)] = s; });
    return { byId, byName, n: data.length };
  }, [data]);
}

export function SedeBadge({ id, nome, assistito }) {
  const { byId, byName } = useSedi();
  const s = (id && byId[id]) || (nome && byName[norm(nome)]);
  if (!s) return null;
  return <>
    <span className="inline-flex items-center gap-0.5 ml-1 align-middle rounded-full border border-amber-300 bg-amber-50 px-1.5 py-px text-[10px] font-bold text-amber-800 whitespace-nowrap shrink-0" title={`Vive in ${s.sede_nome}, assistito da ${s.assistito_da}`} data-testid={`sede-badge-${s.ospite_id}`}>⌂ {s.sede_nome}{s.camera ? ` · cam. ${s.camera}` : ""}</span>
    {assistito && <span className="inline-flex items-center ml-1 align-middle rounded-full border border-sky-300 bg-sky-50 px-1.5 py-px text-[10px] font-bold text-sky-800 whitespace-nowrap" data-testid={`assistito-badge-${s.ospite_id}`}>♥ assistito da {s.assistito_da}</span>}
  </>;
}

export function SedeFiltro({ value, setValue, nomeStruttura, testid = "sede-filtro" }) {
  const { n } = useSedi();
  if (!n) return null;
  const op = [["tutti", "Tutti"], ["qui", `Solo ${nomeStruttura || "struttura"}`], ["sede", "Solo altra sede"]];
  return <span className="inline-flex items-center gap-1 text-xs" data-testid={testid}><span className="text-muted-foreground">Mostra:</span>{op.map(([k, l]) => <button key={k} type="button" onClick={() => setValue(k)} className={`rounded-full border px-2.5 py-1 font-bold ${value === k ? "bg-primary text-white border-primary" : k === "sede" ? "bg-white text-amber-800" : "bg-white"}`} data-testid={`${testid}-${k}`}>{l}</button>)}</span>;
}

export const filtraSede = (byId, v, id) => (v === "tutti" ? true : v === "sede" ? !!byId[id] : !byId[id]);
